import { get } from '@/api/request';

function fetchPayrolls(params = {}) {
  return get('/payroll', params);
}

function exportPayroll(params = {}) {
  return get('/payroll/export', params);
}

export default {
  fetchPayrolls,
  exportPayroll,
};



// WEBPACK FOOTER //
// ./src/store/modules/payroll/api.js